import { ElementKind, Section, WidgetData } from '@playbooks/core/src/interfaces/ActionCard'

function getAllWidgetElements(sections: Section[]) {
  return sections.flatMap(sec => {
    return (
      sec.elements?.flatMap<WidgetData>(element =>
        element.kind === ElementKind.WIDGET ? (element as WidgetData) : [],
      ) || []
    )
  })
}

export default getAllWidgetElements
